$(document).ready(function () {
    const historySupported = !!window.history && !!history.pushState;

    $('[name="subtype"]').change(function () {
        const type = $(this).val();

        $.ajax({
            method: 'GET',
            url: '/subscribe/' + type,
            data: { subtype: type },
            dataType: 'json',
            success: function (res) {
                showHide(type);
                window.title = res.title;
                $('#formContainer').removeClass().addClass(res.class);
                $('#formTitle').html(res.title);
                $('#formDescription').html(res.description);
            }
        });
    });

    function showHide(type) {
        switch(type) {
        case 'email':
        case 'friend':
            $('tr.mail').addClass('hidden');
            $('tr.email.hidden').removeClass('hidden');
            break;
        case 'mail':
            $('tr.email').addClass('hidden');
            $('tr.mail.hidden').removeClass('hidden');
            break;
        default:
            $('tr.email.hidden').removeClass('hidden');
            $('tr.mail.hidden').removeClass('hidden');
            break;
        }

        if (historySupported) changeHistory(type);
    }

    function changeHistory(type) {
        let loc = '';

        switch (type) {
        case 'email':
            loc = '/email';
            break;
        case 'mail':
            loc = '/mail';
            break;
        }

        history.replaceState({}, '', '/subscribe' + loc);
    }
});